// action creators

export const LOAD_CMS_PAGE = 'LOAD_CMS_PAGE'; 
export const GET_CMS_MAIN_MENU = "GET_CMS_MAIN_MENU";

const cmsPage = (page, errorPage = null, isPlaces = false, alternativeContent = null) => {
    return async(dispatch, getState, {CmsApi}) => {

        const {Cms: {isPending}} = getState();
        if(!isPending) {
            dispatch(loadCmsPagePending());
        }
        dispatch(loadCmsPagePending());
        
        try {
            const {code, data = {}} = await CmsApi.getCmsPage(errorPage || page);
            if (code != 200) {
                if(code == 404){
                    if(alternativeContent) {
                        return dispatch(cmsPage(page, alternativeContent, isPlaces));
                    } else if (!isPlaces) {
                        return dispatch(cmsPage(page, 'error404'));
                    }
                } else {
                    throw {message: translation(`cmsPage_error${code}`)};
                }
            }

            const cmsPageData = {name: page, data};
            dispatch(loadCmsPageSuccess(cmsPageData));

            return cmsPageData;

        } catch ({error}) {
            dispatch(loadCmsPageFailure(error));
            throw error;
        }
    }
};

const createMarkup = (html) => {
    return {__html: html};
}

const loadCmsPageFailure = (error) => {
    return {
        type: `${LOAD_CMS_PAGE}_FAILURE`,
        payload: {error}
    }
};

const loadCmsPageSuccess = (callCmsPage) => {
    return {
        type: `${LOAD_CMS_PAGE}_SUCCESS`,
        payload: {callCmsPage}
    }
};

const loadCmsPagePending = () => {
    return {
        type: `${LOAD_CMS_PAGE}_PENDING`
    }
};

const getCmsMainMenuPending = () => {
    return {
        type: `${GET_CMS_MAIN_MENU}_PENDING`
    }
}

const getCmsMainMenuSuccess = (subCategories) => {
    return {
        type: `${GET_CMS_MAIN_MENU}_SUCCESS`,
        payload: { subCategories }
    }
}

const getCmsMainMenuFailure = (error) => {
    return {
        type: `${GET_CMS_MAIN_MENU}_FAILURE`,
        payload: { error }
    }
}

const getCmsMainMenu = (language, countryCode) => {
    return async(dispatch, getState, { CmsApi }) => {
        dispatch(getCmsMainMenuPending())

        try {
            const { code, data } = await CmsApi.getCmsMainMenu(language, countryCode)
            if (code !== 200 || !data?.subCategories?.length) {
                dispatch(getCmsMainMenuSuccess([]))
                return
            }

            dispatch(getCmsMainMenuSuccess(data.subCategories))
            return data.subCategories
        } catch (error) {
            dispatch(getCmsMainMenuFailure(error))
        }
    }
}

export { cmsPage, createMarkup, getCmsMainMenu };